import React from 'react'
import PropTypes from 'prop-types'
import { observable } from 'mobx'
import { observer, inject } from 'mobx-react'
import { Tabs, Tab, DropdownButton, MenuItem, Button } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import AmazonEditForm from './platforms/amazon'
import ModalButton from '../utils/modalButton'
import CommonEditForm from './platforms/common'
import EditView from 'bstrap-react-mobx-admin/view/edit'
import FlyPrivateEditForm from './platforms/flyprivate'
import GoogleplayEditForm from './platforms/googleplay'
import HelpOverlay from '../utils/helpOverlay'
import ItunesplayEditForm from './platforms/itunes'
import MicrosoftEditForm from './platforms/microsoft'
import UpcEditForm from './platforms/upc'
import YoutubeEditForm from './platforms/youtube'

const FilmEditForm = ({ store, isBundleType }) => {
  const entity = store.cv.record
  const updateField = store.cv.updateData.bind(store.cv)
  const onReturn2list = store.onReturn2list.bind(store)
  const disabled = !store.hasRight(defaultConst.ENTNAMES.FILMS, 'w')
  const showTabs = {}

  // add default platform type for bundles
  const existingPlatforms = store.cv.record.has('platforms')
    ? store.cv.record.get('platforms').split('|')
    : []
  if (isBundleType && !existingPlatforms.includes('FP')) {
    store.addPlatform({ value: 'flyprivate' })
  }

  const arrayMap = observable.map({})
  entity.get('attrs').map((i) => {
    const key = `${i.platform}.${i.name}`
    arrayMap.set(key, i.value)
  })

  store.router.publish.trailer = null
  store.router.publish.offline = null

  const _platformComponentMapping = {
    [defaultConst.PLATFORMS_NAMES.flyprivate]: FlyPrivateEditForm,
    [defaultConst.PLATFORMS_NAMES.amazon]: AmazonEditForm,
    [defaultConst.PLATFORMS_NAMES.googleplay]: GoogleplayEditForm,
    [defaultConst.PLATFORMS_NAMES.itunes]: ItunesplayEditForm,
    [defaultConst.PLATFORMS_NAMES.microsoft]: MicrosoftEditForm,
    [defaultConst.PLATFORMS_NAMES.upc]: UpcEditForm,
    [defaultConst.PLATFORMS_NAMES.youtube]: YoutubeEditForm
  }

  const TabsComponent = observer(({ id }) => {
    let ek = 1
    const activeTabs = Object.keys(_platformComponentMapping).map((i, idx) => {
      ek++
      const activePlatforms = store.cv.record.has('platforms')
        ? store.cv.record.get('platforms').split('|')
        : []
      const Component = i && activePlatforms.length > 0 &&
        activePlatforms.indexOf(i) >= 0 && _platformComponentMapping[i]
      if (Component) {
        showTabs[ek] = i
      }
      return Component && <Tab eventKey={ek} key={ek} title={
        <div>
          {store.platformTitle(i)}
          <HelpOverlay store={store} path={'films/' + i} />
        </div>}>
        <Component assetTabs={store.assetTabs.flyprivate}
          store={store} updateField={updateField} arrayMap={arrayMap}
          disabled={disabled} disabledRemove={disabled} isBundleType={isBundleType}
        />
      </Tab>
    })

    const tabs = (
      <Tabs activeKey={showTabs[store.assetTabs.basic]
        ? store.assetTabs.basic
        : 1}
      onSelect={tab => store.assetTabEvent('basic', tab)}>
        <Tab eventKey={1} title={
          <div>
            {store.__('Common')}
            <HelpOverlay store={store} path='films/common' />
          </div>}>
          <CommonEditForm assetTabs={store.assetTabs.common}
            autoSLug={store.cv.autoValues.slug} autoName={store.cv.autoValues.name}
            store={store} isBundleType={isBundleType} updateField={updateField} arrayMap={arrayMap}
            onReturn2list={onReturn2list} disabled={disabled}
          />
        </Tab>
        {activeTabs}
      </Tabs>
    )

    return (
      <div>
        <Helmet title={store.__(linkConst.LINK_FILMS_TITLE).concat(defaultConst.HTML_DIVIDER) + (store.cv.origRecordId
          ? (store.cv.record && store.cv.record.has('title')
            ? store.cv.record.get('title')
            : store.__(defaultConst.TITLE_EDIT))
          : store.__(defaultConst.TITLE_CREATE))} />
        {tabs}
      </div>
    )
  })

  return (
    <div>
      <TabsComponent id='assetPlatforms' />
    </div>
  )
}
FilmEditForm.propTypes = {
  store: PropTypes.object.isRequired,
  isBundleType: PropTypes.boolean
}

const FilmEditView = ({ store }) => {
  //
  if (!store.hasRight(defaultConst.ENTNAMES.FILMS)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  const isBundleType = (store.router.queryParams && store.router.queryParams.hasOwnProperty('type') &&
    store.router.queryParams.type === 'bundle') ||
    (store.cv.record.has('video_type') && store.cv.record.get('video_type') === 'BUNDLE')

  const AddPlatformDropDown = observer(({ store }) => {
    const title = (<span><span className='glyphicon glyphicon-plus-sign' /> {store.__(defaultConst.TITLE_ADD_PLATFORM)} </span>)
    const disabled = !store.hasRight(defaultConst.ENTNAMES.FILMS, 'w')
    if (disabled) {
      console.log('No rights for: ADD PLATFORM button')
    }
    return !disabled && store.inactive_platforms.length > 0 && (
      <div className='buttons-vertical-align'>
        <DropdownButton bsStyle='primary' title={title} id='add_platforms_dropdown'>
          {
            store.inactive_platforms.map((i, idx) => (
              <MenuItem eventKey={i.value} key={idx} onClick={() => store.addPlatform(i)}>
                {i.text}
              </MenuItem>
            ))
          }
        </DropdownButton>
      </div>
    )
  })

  const itemId = store.cv.record.has('id') && store.cv.record.get('id')
  const AddTitlesButton = observer(({ store }) => {
    const disabled = !store.hasRight(defaultConst.ENTNAMES.CONTRACTITEMS)
    if (disabled) {
      console.log('No rights for: CONTRACT ITEMS button')
    }
    return !disabled
      ? (<div key='additem' className='buttons-vertical-align' style={{ display: 'inline-block' }}>
        <HelpOverlay helpContent='Show titles/contractitems associated with this film'><Button
          disabled={!itemId} title={!itemId ? store.__('Requires save before adding contract item') : ''}
          bsStyle='info' onClick={() => {
            store.goTo('contractitems', { entname: 'film', id: store.cv.record.get('id') })
          }}>
          <span className='glyphicon glyphicon-share-alt' />&nbsp; {store.__(linkConst.LINK_FILM_ITEMS_TITLE)}
        </Button></HelpOverlay>
      </div>)
      : null
  })

  const contractItemsButton = [
    (<AddTitlesButton key='1' store={store} />),
    (!isBundleType && <AddPlatformDropDown key='2' store={store} />),
    (itemId && <ModalButton key='3' store={store} modal={store.modalEntity} />)
  ]

  return (
    <EditView store={store.cv} onReturn2list={store.onReturn2list.bind(store)}
      onSave={() => store.cv.save()}
      enabled={store.hasRight(defaultConst.ENTNAMES.FILMS, 'w')}
      options={{ customActionButtons: contractItemsButton }}>
      <FilmEditForm store={store} isBundleType={isBundleType} />
    </EditView>
  )
}
FilmEditView.propTypes = {
  store: PropTypes.object.isRequired
}

export default inject('store')(observer(FilmEditView))
